module.exports = __webpack_public_path__ + "static/media/mmm-icon-noneOption.de5d2020.svg";